import appAxios from 'api/appAxios';
import { setHeadersInStorage } from 'api/utilities/headersHandler';

const makeDeleteRequest = async (endpoint) => {
  const { data } = await appAxios.delete(endpoint);
  setHeadersInStorage(data);
  return data;
};

export default makeDeleteRequest;
